import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';

export const forceLoginResetUserThunk = createAdminAsyncThunk<
  undefined,
  { id: string }
>(
  'organizationUsers/forceLoginReset',
  async({ id }, { extra: { usersService } }) => {
    await usersService.forceLoginResetUser(id);
    return undefined;
  }
);
